export default __webpack_public_path__ + "static/media/mobine_antony.1f800a93.png";